<template>
<div class="chapter">
<div class="inner_page">
<a id="pv"></a>
<blockquote class="sink">
<p class="right "><em>To all the patriotic Egyptians, Tunisians, and the</em><br/>
<em>rest of the Arabs who took over the streets and</em><br/>
<em>made history that inspired the world</em></p>
<div class="timebreak "> </div>
<p class="right "><em>To every brave man and woman who</em><br/>
<em>made the ultimate sacrifice</em></p>
<div class="timebreak "> </div>
<p class="right "><em>To future generations, in hopes that they</em><br/>
<em>will live in a free and democratic world </em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?40a52379